import { render, staticRenderFns } from "./ComponentManagement.vue?vue&type=template&id=7bce47a3&scoped=true"
import script from "./ComponentManagement.vue?vue&type=script&lang=js"
export * from "./ComponentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce47a3",
  null
  
)

export default component.exports